import axios from 'axios';
import { API_URL } from '@/lib/config';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Her istekte token ekle
api.interceptors.request.use((config) => {
  if (typeof window !== 'undefined') {
    const authStorage = localStorage.getItem('auth-storage');
    if (authStorage) {
      const parsed = JSON.parse(authStorage);
      const token = parsed?.state?.token;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
  }
  return config;
});

// 401 hatasında login sayfasına yönlendir
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && typeof window !== 'undefined') {
      if (!window.location.pathname.includes('/giris') &&
          !window.location.pathname.includes('/auth')) {
        localStorage.removeItem('auth-storage');
        window.location.href = '/giris';
      }
    }

    // Hata mesajını string'e normalize et
    if (error.response?.data) {
      const data = error.response.data;
      if (typeof data.message === 'string') {
        error.message = data.message;
      } else if (Array.isArray(data.message)) {
        error.message = data.message.join(', ');
      } else if (typeof data === 'string') {
        error.message = data;
      } else {
        error.message = 'Hata oluştu';
      }
    }

    return Promise.reject(error);
  },
);

export default api;